<div [class]="theme">
  <header class="flex">
    <ng-container *ngIf="coreFacade.bannerState$ | async as bannerState">
      <nx-ng-banner
        *ngIf="bannerState.isEnabled"
        [title]="bannerState.title"
        [text]="bannerState.description"
        [textColour]="bannerState.textColour || ''"
        [backgroundColour]="bannerState.backgroundColour || ''"
        [link]="bannerState.link"
        (close)="handleDismissBanner()"
      >
      </nx-ng-banner>
    </ng-container>
  </header>

  <ng-container *ngIf="!env.production">
    <button
      *ngIf="(b2cEventsService.isLoggedIn$ | async) === false"
      (click)="login()"
    >
      Login
    </button>
    <button *ngIf="b2cEventsService.isLoggedIn$ | async" (click)="logout()">
      Logout
    </button>
  </ng-container>
  <main>
    <ng-container *ngIf="!env.production">
      <a [routerLink]="['account']">Customer Details</a> |
      <a [routerLink]="['/types']" [routerLinkActive]="'is-active'">
        Ticket Types
      </a>
      |
      <a [routerLink]="['/select']" [routerLinkActive]="'is-active'">
        Ticket Selector
      </a>
      <a [routerLink]="['/details']">Booking Summary</a> |
      <a
        [routerLink]="['/confirmation']"
        [queryParams]="{ orderNumber: 400000166 }"
        >Booking Confirmation</a
      >
      | <a [routerLink]="['pay']">Direct Debit</a> |
    </ng-container>
    <nx-ng-layout
      [currentStep]="currentStep"
      [basketItemsTotal]="(checkoutFacade.totalBasketQuantityCount$ | async) || 0"
      [showBreadcrumb]="true"
      [parentWebsite]="parentWebsite"
    >
      <router-outlet #outlet="outlet"></router-outlet>
    </nx-ng-layout>
  </main>
  <nx-ng-footer [label]="'footer'"></nx-ng-footer>
</div>
